<template>
  <span>
    <AppSelectCheckboxes
      v-if="
        typeof showCheckboxesView === 'function'
          ? showCheckboxesView()
          : showCheckboxesView
      "
      v-model="givenValue"
      :items="levels"
      :label="$t(label)"
      item-value="id"
      item-text="name"
      v-bind="$attrs"
      box-color="secondary"
    />
    <v-autocomplete
      v-else
      v-model="givenValue"
      v-show-fade="{ isFilter: isFilter }"
      :items="levels"
      :class="[selectMixinClass]"
      :label="label"
      v-bind="$attrs"
      item-value="id"
      :data-test="dataTest"
      item-text="name"
      :clearable="clearable"
      hide-no-data
      outlined
      @change="inputVisibility($event, 'change')"
      @focus="focused"
      @blur="inputVisibility"
    />
  </span>
</template>

<script>
import AppSelectCheckboxes from "./AppSelectCheckboxes.vue";
import { useCompetitionLevelHelper } from "@composables/masterdata/competitions/competitionLevels";
import selectsMixin from "./selects_mixin";
export default {
  name: "AppSelectCompetitionLevels",
  components: { AppSelectCheckboxes },
  mixins: [selectsMixin],
  props: {
    value: {
      type: [String, Array],
      default: null
    },
    possibleValues: {
      type: Array,
      default: () => []
    },
    label: {
      type: String,
      default() {
        return this.$t(
          "events:common.competitionLevel.label",
          "Competition level",
          "Label for competition level in different parts of the system"
        );
      }
    },
    dataTest: {
      type: String,
      default: "competitionLevels"
    }
  },
  setup() {
    return {
      ...useCompetitionLevelHelper()
    };
  },
  computed: {
    givenValue: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit("input", v);
      }
    },
    levels() {
      if (this.possibleValues.length) {
        return this.masterCompetitionLevelsActive.filter(({ id }) =>
          this.possibleValues.includes(id)
        );
      }
      return this.masterCompetitionLevelsActive;
    }
  },
  created() {
    if (!this.value && this.levels.length == 1) {
      this.givenValue = this.levels[0].id;
    }
  }
};
</script>
